export default __webpack_public_path__ + "static/media/846.4c9070e3.png";